export default () => ({
  root: {
  },
  label: {
    display: 'inline-block',
    width: '120px',
  },
})
